export default "__VITE_ASSET__Un84vikx__"